/* eslint-disable @typescript-eslint/no-shadow */

/* eslint-disable react/button-has-type */
import { useRouter } from 'next/router';

import React, { ReactElement } from 'react';
import { isDesktop } from 'react-device-detect';

import { css } from '@emotion/react';
import { SearchType } from '@type/web/fraud';

import useBoolean from '@hook/useBoolean';

import useFraudSearchForm from '../hook/useFraudSearchForm';
import FraudSearchFooter from './FraudSearchFooter';
import FraudSearchInput from './FraudSearchInput';
import FraudSearchType from './FraudSearchType';

const WARN_TEXT = {
  PHONE_NUMBER: '휴대폰 번호를 다시 확인해주세요',
  ACCOUNT_NUMBER: '계좌 번호를 다시 확인해주세요',
  KAKAO_ID: '영문, 숫자, 빼기(-), 밑줄(_), 마침표(.)만 입력해주세요',
  EMAIL: '이메일을 다시 확인해주세요',
};

function FraudSearchForm(): ReactElement {
  const { type, isValid, inputValue, selectType, handleChange } =
    useFraudSearchForm();

  const { value: visible, toggle: onToggle } = useBoolean();

  const handleSelect = (type: SearchType) => {
    onToggle();
    selectType(type);
  };

  const { push } = useRouter();

  const handleOnKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter')
      push({ pathname: '/fraud/result', query: { inputValue, type } });
  };

  return (
    <div css={container}>
      <div css={description}>
        <p>판매자의 휴대폰, 계좌번호, 메신저 ID, 이메일로</p>
        <p>피해 사례 조회를 이용해 보세요!</p>
      </div>
      <FraudSearchType
        visible={visible}
        onToggle={onToggle}
        handleSelect={handleSelect}
        type={type}
      />
      <FraudSearchInput
        handleOnKeyPress={handleOnKeyPress}
        handleSelect={handleSelect}
        onToggle={onToggle}
        fraudSearchForm={{ isValid, visible, inputValue, handleChange, type }}
      />
      {!isValid && inputValue.length > 0 && (
        <p css={warnText}>{WARN_TEXT[type]}</p>
      )}
      {!isDesktop && (
        <div css={deepLinkContainer}>
          <a href="https://tracking.joongna.com/mhxcdc" css={appDeepLink}>
            중고나라 앱에서 조회하기 &gt;
          </a>
        </div>
      )}

      <FraudSearchFooter />
    </div>
  );
}

const container = css`
  position: relative;
  padding: 13px 20px;
`;

const description = css`
  padding-bottom: 20px;
  line-height: 25px;
`;

const warnText = css`
  font-size: 12px;
  margin-top: 8px;
  padding: 0 20px;
  color: #da1e28;
`;

const deepLinkContainer = css`
  padding-top: 16px;
`;
const appDeepLink = css`
  font-size: 13.5px;
  font-weight: 700;
  color: #ff6c2d;
`;

export default FraudSearchForm;
